import React from 'react';
import { DEFAULT_MONTH, PERIOD_LABELS } from '../constants/monthConfig';
import { DOMAINS, getSummaryPills } from '../constants/domainConfig';

export default function SummaryBand({ activeDomain = 'fibre', selectedMonth = DEFAULT_MONTH }) {
  const config = DOMAINS[activeDomain] || DOMAINS.fibre;
  const periodLabel = PERIOD_LABELS[selectedMonth] || PERIOD_LABELS[DEFAULT_MONTH];
  const pills = getSummaryPills(activeDomain, selectedMonth);
  const subtitle = config.summarySubtitle.replace('{period}', periodLabel);

  const netPayablePill = pills.find((pill) => pill.label === 'Net Payable');
  const leadingPills = netPayablePill ? pills.filter((pill) => pill.label !== 'Net Payable') : pills;

  const renderPill = (pill) => (
    <div
      key={pill.label}
      className="soft-pill text-white"
      style={{
        background: 'rgba(255,255,255,0.10)',
        borderColor: 'rgba(255,255,255,0.14)',
      }}
    >
      <span className="soft-pill-label" style={{ color: 'rgba(255,255,255,0.62)' }}>
        {pill.label}
      </span>
      <span className="soft-pill-value text-white">{pill.value}</span>
    </div>
  );

  return (
    <section
      className="overflow-hidden rounded-2xl lg:min-h-[152px]"
      style={{
        background: 'linear-gradient(135deg, #041f3d 0%, #062B55 58%, #0a3768 100%)',
        border: '1px solid rgba(111, 168, 247, 0.18)',
        boxShadow: '0 10px 28px rgba(6, 43, 85, 0.18)',
      }}
    >
      <div className="flex h-full flex-col gap-5 px-6 py-6 sm:px-8 lg:min-h-[152px] lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-3xl">
          <h1 className="text-[1.4rem] font-semibold leading-tight tracking-[-0.03em] text-white sm:text-[1.55rem]">
            {config.summaryTitle}{' '}
            <span className="text-accent">{config.summaryHighlight}</span>
          </h1>
          <p
            className="mt-2 text-sm leading-relaxed"
            style={{ color: 'rgba(255,255,255,0.56)' }}
          >
            {subtitle}
          </p>
        </div>

        <div className="flex flex-col gap-2 lg:items-end">
          <div
            className={
              activeDomain === 'executive'
                ? 'flex flex-col gap-2 lg:items-end'
                : 'flex flex-wrap gap-2 lg:justify-end'
            }
          >
            {leadingPills.map(renderPill)}
          </div>
          {netPayablePill ? (
            <div className="flex lg:justify-end">
              {renderPill(netPayablePill)}
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
